import Vue from "vue";
import VueRouter from "vue-router";
import NotFound from "@/views/home/E404";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "登录", component: () => import("@/views/login/Login") },
  {
    path: "",
    name: "Admin",
    component: () => import("@/layouts/AdminBasics"),
    children: [
      /*************IT管理的应用权限************/
      {
        path: "/itset/apps",
        name: "应用管理",
        component: () => import("@/views/itset/Apps"),
      },
      {
        path: "/itset/osscontrol",
        name: "oss系统菜单",
        component: () => import("@/views/itset/OssControl"),
      },
      {
        path: "/itset/admincontrol",
        name: "admin系统菜单",
        component: () => import("@/views/itset/Admincontrol"),
      },
      {
        path: "/itset/weappcontrol",
        name: "WeApp接口",
        component: () => import("@/views/itset/Weappcontrol"),
      },
      /*************IT管理的应用权限 end************/
      /*************模板************/
      {
        path: "/template/dialog",
        name: "弹窗",
        component: () => import("@/views/template/Dialog"),
      },
      {
        path: "/template/list_table",
        name: "模板列表（表格）",
        component: () => import("@/views/template/ListTable"),
      },
      {
        path: "/template/form",
        name: "模板表单",
        component: () => import("@/views/template/Form"),
      },
      {
        path: "/template/info",
        name: "详情",
        component: () => import("@/views/template/Info"),
      },
      {
        path: "/template/amap",
        name: "地图",
        component: () => import("@/views/template/Amap"),
      },
      {
        path: "/template/upload",
        name: "上传",
        component: () => import("@/views/template/Upload"),
      },
      {
        path: "/template/echarts",
        name: "数据统计图",
        component: () => import("@/views/template/Echarts"),
      },
      {
        path: "/template/cropper_image",
        name: "截图",
        component: () => import("@/views/template/CropperImage"),
      },
      /*************模板 end************/
      /*************主页基础************/
      {
        path: "/home",
        name: "数据报表",
        component: () => import("@/views/home/Home"),
      },
      {
        path: "/home/password",
        name: "修改密码",
        component: () => import("@/views/home/Password"),
      },
      /*************主页基础 end************/
      /*************协议************/
      {
        path: "/agreement/register",
        name: "注册协议",
        component: () => import("@/views/agreement/Register"),
      },
      {
        path: "/agreement/community",
        name: "信息协议",
        component: () => import("@/views/agreement/Community"),
      },
      /*************协议end************/
      /*************企业管理************/
      {
        path: "/company/new",
        name: "新企业",
        component: () => import("@/views/company/New"),
      },
      {
        path: "/company/examine",
        name: "待审核企业",
        component: () => import("@/views/company/Examine"),
      },
      {
        path: "/company/addexamine",
        name: "开户审核",
        component: () => import("@/views/company/addexamine"),
      },
      {
        path: "/company",
        name: "企业列表",
        component: () => import("@/views/company/List"),
      },
      {
        path: "/company/overdue",
        name: "已过期企业",
        component: () => import("@/views/company/Overdue"),
      },
      {
        path: "/company/add",
        name: "添加企业",
        component: () => import("@/views/company/Add"),
      },
      {
        path: "/company/info",
        name: "企业信息",
        component: () => import("@/views/company/Info"),
      },
      /*************企业管理end************/
      /*************数据设置************/
      {
        path: "/content/tag",
        name: "内容标签",
        component: () => import("@/views/content/tag/List"),
      },
      {
        path: "/content/class",
        name: "内容分类",
        component: () => import("@/views/content/class/List"),
      },
      {
        path: "/community/class",
        name: "信息分类",
        component: () => import("@/views/community/class/List"),
      },
      {
        path: "/goods/tag",
        name: "内容标签-php",
        component: () => import("@/views/goods/tag/List"),
      },
      {
        path: "/goods/class",
        name: "内容分类-php",
        component: () => import("@/views/goods/class/List"),
      },
      {
        path: "/member/index",
        name: "会员配置",
        component: () => import("@/views/member/index"),
      },
      {
        path: "/integral/index",
        name: "积分配置",
        component: () => import("@/views/integral/index"),
      },
      {
        path: "/order/service",
        name: "商品保障设置",
        component: () => import("@/views/goods/order/Service.vue"),
      },
      {
        path: "/order/logistics",
        name: "商品快递设置",
        component: () => import("@/views/goods/order/Logistics.vue"),
      },
      {
        path: "/orderbill",
        name: "分账列表",
        component: () => import("@/views/orderbill/list"),
      },
      {
        path: "/orderbill/info",
        name: "分账详情",
        component: () => import("@/views/orderbill/info"),
      },
      {
        path: "/order",
        name: "订单管理",
        component: () => import("@/views/order/list"),
      },
      {
        path: "/order/info",
        name: "订单详情",
        component: () => import("@/views/order/info"),
      },
      /*************数据设置end************/
      /*************系统设置************/
      {
        path: "/sys/role",
        name: "角色列表",
        component: () => import("@/views/sys/role/List"),
      },
      {
        path: "/sys/role/edit",
        name: "角色编辑",
        component: () => import("@/views/sys/role/Edit"),
      },
      {
        path: "/sys/user",
        name: "用户列表",
        component: () => import("@/views/sys/user/List"),
      },
      {
        path: "/sys/user/edit",
        name: "用户编辑",
        component: () => import("@/views/sys/user/Edit"),
      },
      {
        path: "/sys/log",
        name: "系统日志",
        component: () => import("@/views/sys/log/List"),
      },
      /*************系统设置end************/
      {
        path: "/share/audit/b/v1/page",
        name: "订单审批",
        component: () => import("@/views/approval/Approval.vue"),
      },
      {
        path: "/share/city/page",
        name: "共享城市管理",
        component: () => import("@/views/approval/shareCity.vue"),
      },
      {
        path: "/approvalDetail",
        name: "审批详情",
        component: () => import("@/views/approval/approvalDetail.vue"),
      },
      {
        path: "/grassApprovalDetail",
        name: "审批详情",
        component: () => import("@/views/approval/grassApprovalDetail.vue"),
      },

      {
        path: "/share/community/page",
        name: "信息审核管理",
        component: () => import("@/views/community/apply/Apply.vue"),
      },
      {
        path: "/share/community/detail",
        name: "信息详情",
        component: () => import("@/views/community/apply/Detail.vue"),
      },

      /*************共享中心************/
      {
        path: "/share/rotationA/b/v1/list",
        name: "第一广告位",
        component: () => import("@/views/shared/firstSpace"),
      },
      {
        path: "/share/rotationB/b/v1/list",
        name: "第二广告位",
        component: () => import("@/views/shared/secondSpace"),
      },
      {
        path: "/share/rank/b/v1/list",
        name: "排行榜",
        component: () => import("@/views/shared/rankingList"),
      },
      {
        path: "/share/rotationC/b/v1/list",
        name: "第三广告位",
        component: () => import("@/views/shared/thirdSpace"),
      },
    ],
  },
  { path: "*", name: "NotFound", component: NotFound },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
